import { useContext, useEffect, useState } from "react";
import HttpContext from "core/utils/httpContext";

/**
 * WebView мобильного приложения sports.ru.
 * Приложение присылает заголовок x-platform: mobile_app, сервер в ответ
 * ставит cookie: WKWebView отправляет кастомный заголовок только на первый
 * запрос, а при перезагрузке или из кэша HTML платформу узнаём по cookie
 */
export const MOBILE_APP_PLATFORM = "mobile_app";
export const MOBILE_APP_HEADER = "x-platform";
export const MOBILE_APP_COOKIE = "x_platform";

export function isMobileAppRequest(req) {
  return (
    req.header(MOBILE_APP_HEADER) === MOBILE_APP_PLATFORM ||
    req.cookies?.[MOBILE_APP_COOKIE] === MOBILE_APP_PLATFORM
  );
}

export function isMobileAppClient() {
  if (typeof window === "undefined") return false;

  if (window.__PLATFORM__ === MOBILE_APP_PLATFORM) return true;

  return document.cookie
    .split("; ")
    .includes(`${MOBILE_APP_COOKIE}=${MOBILE_APP_PLATFORM}`);
}

/**
 * Первый рендер совпадает с разметкой сервера, cookie проверяем после
 * гидрации: закэшированный HTML мог быть собран для обычного браузера
 */
export function useIsMobileApp() {
  const { isMobileApp: isRenderedForApp = false } = useContext(HttpContext);

  const [isMobileApp, setIsMobileApp] = useState(
    typeof window === "undefined"
      ? isRenderedForApp
      : window.__PLATFORM__ === MOBILE_APP_PLATFORM
  );

  useEffect(() => {
    if (isMobileAppClient()) {
      setIsMobileApp(true);
    }
  }, []);

  return isMobileApp;
}
